import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router';

import { useSignUpMutation } from 'api/main';
import { RoleNames } from 'utils/constants';
import { texts } from 'utils/languages/fr';

import TunnelStep from '../../common/TunnelStep';
import DistributorTypeChoice from '../../onboarding/DistributorTypeChoice';
import PPForm from './PPForm';
import PMForm from './PMForm';
import DistributorForm from './DistributorForm';
import { Typography } from '@mui/material';

const AccountCreation = props => {
    const { roleName, isDistTypeChoiceStepConfirmed, ...rest } = props;

    const location = useLocation();
    const [distributorTypeSubmitted, setDistributorTypeSubmitted] = useState(
        isDistTypeChoiceStepConfirmed
    );
    const [, { isSuccess: successfulSignUp }] = useSignUpMutation({ fixedCacheKey: 'register' });
    const distributorIsOnboarding = location.pathname.includes('/onboarding');

    const userIsDistributor = useMemo(
        () => roleName === RoleNames.PSI || roleName === RoleNames.ADMIN_CIF,
        [roleName]
    );
    const userIsInvestor = useMemo(
        () => roleName === RoleNames.PP_PROFESSIONNEL || roleName === RoleNames.PM_PROFESSIONNEL,
        [roleName]
    );

    const subtitle = useMemo(() => {
        if (successfulSignUp && !rest.userStep) {
            return <Typography variant="subtitle1">{texts.ESPACE_PEQAN_DEDIE_SUCCESS}</Typography>;
        } else if (userIsInvestor) {
            return <Typography variant="subtitle1">{texts.ESPACE_PEQAN_DEDIE}</Typography>;
        }
        return null;
    }, [successfulSignUp, rest.userStep, userIsInvestor]);

    if (distributorIsOnboarding && !distributorTypeSubmitted) {
        return (
            <DistributorTypeChoice
                roleName={roleName}
                onConfirm={() => setDistributorTypeSubmitted(true)}
                {...rest}
            />
        );
    }

    return (
        <TunnelStep title={texts.ACCOUNT_CREATION} subtitle={subtitle}>
            {roleName === RoleNames.PP_PROFESSIONNEL && <PPForm roleName={roleName} {...rest} />}
            {roleName === RoleNames.PM_PROFESSIONNEL && <PMForm roleName={roleName} {...rest} />}
            {userIsDistributor && <DistributorForm roleName={roleName} {...rest} />}
        </TunnelStep>
    );
};

AccountCreation.propTypes = {
    roleName: PropTypes.string,
    isDistTypeChoiceStepConfirmed: PropTypes.bool,
};

export default AccountCreation;
